var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 11,
    viewBox: "0 0 8 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C3.44767 5 3 4.55233 3 4C3 3.44767 3.44767 3 4 3C4.55233 3 5 3.44767 5 4C5 4.55233 4.55233 5 4 5ZM4 2.33333C3.07967 2.33333 2.33333 3.07933 2.33333 4C2.33333 4.92067 3.07967 5.66667 4 5.66667C4.92033 5.66667 5.66667 4.92067 5.66667 4C5.66667 3.07933 4.92033 2.33333 4 2.33333ZM4 9.66667C3.44567 9.66967 0.666667 5.39367 0.666667 4C0.666667 2.15933 2.159 0.666667 4 0.666667C5.841 0.666667 7.33333 2.15933 7.33333 4C7.33333 5.375 4.54567 9.66967 4 9.66667ZM4 0C1.791 0 0 1.791 0 4C0 5.67267 3.335 10.6703 4 10.6667C4.65467 10.6703 8 5.65 8 4C8 1.791 6.209 0 4 0Z",
    fill: "#4A5565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location_icon.3289ffbf9f35a9f77ea0a05e171a260e.svg";
export { ForwardRef as ReactComponent };